export default __webpack_public_path__ + "static/media/lineup-iphone-x-screenshot-skippable-new.ee54948a.png";